import { DevelopmentServices } from '@components/sections/DevelopmentServices'
import { Description } from '@ui/sections/Description'

import { config } from './config'
import { Wrapper, WideTechStackWrapper } from './styles'

export function ExtensiveTechStack() {
  return (
    <Wrapper>
      <Description {...config.titleProps} />
      <WideTechStackWrapper>
        <DevelopmentServices config={config} hover />
      </WideTechStackWrapper>
    </Wrapper>
  )
}
